import { usePageStore } from '@/store';
import { BAHAMAS_MLS_ID } from '@/common/mls';

export const getAgent = async function(store) {
    const pageStore = usePageStore(this.$pinia);
    
    let { agentInfo } = this.listingDetail || {};
    if (this.originPriority && agentInfo) {
        store['updateAgentInfo'](agentInfo);
    } else {
        agentInfo = await pageStore.getAgentInfo(this.agentId);
        store['updateAgentInfo'](agentInfo);
    }
};

export function asyncData(store) {
    const pageStore = usePageStore(this.$pinia);
    store['updateListingDetail'](this.listingDetail);
    let ps = [];
    if (!pageStore.companyInfo) {
        ps.push(pageStore.getCompanyInfo());
    }
    if (this.page?.mlsOrgs?.length && this.page?.mlsOrgs[0]?.id && this.page.mlsOrgs[0].id === BAHAMAS_MLS_ID) {
        ps.push(this.getOfficeStatus());
    }
    ps.push(getAgent.call(this, store));
    ps.push(store['queryShowingConfig']());
    ps.push(store['queryRestrictTimeList']());
    return Promise.all(ps);
}
